// extracted by mini-css-extract-plugin
module.exports = {"poster":"style_poster__bh3lj"};